import { createContext, useState } from "react";

const RevisaoContratoContext = createContext();

const RevisaoContratoContextProvider = ({ children }) => {
  const today = new Date(),
    currentDay = today.getDate().toString().padStart(2, "0"),
    currentMonth = (today.getMonth() + 1).toString().padStart(2, "0"),
    currentYear = today.getFullYear();

  // controle da edição do cliente
  const [clientList, setClientList] = useState([]);
  const [currentClientIndex, setCurrentClientIndex] = useState(0);
  const [currentContractIndex, setCurrentContractIndex] = useState(0);
  const [errors, setErrors] = useState({});
  const [disabledButton, setDisabledButton] = useState(false);

  // listas
  const [banksList, setBanksList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [readjustsList, setReadjustsList] = useState([]);
  const [contractTypesList, setContractTypesList] = useState([]);
  const [paymentTypesList, setPaymentTypesList] = useState([]);

  // estados usados nos inputs
  const [currentDate] = useState(
    `${currentYear}-${currentMonth}-${currentDay}`
  );

  const [contractType, setContractType] = useState(null);
  const [service, setService] = useState(null);
  const [readjust, setReadjust] = useState(null);
  const [bank, setBank] = useState(null);
  const [deadline, setDeadline] = useState(
    `${currentYear}-${currentMonth}-${currentDay}`
  );
  const [dueDate, setDueDate] = useState(null);
  const [periodicity, setPeriodicity] = useState(null);
  const [value, setValue] = useState("0,00");
  const [listBillet, setListBillet] = useState([
    { value: "hibrido", label: "CNAB/PIX" },
    { value: "cnab", label: "CNAB" },
    { value: "pix", label: "PIX" },
  ]);
  const [billType, setBillType] = useState();
  const [NFSeType, setNFSeType] = useState({
    label: "No faturamento",
    value: "1",
  });
  const [issueType, setIssueType] = useState(true);
  const [vigency, setVigency] = useState("");
  const [competency, setCompetency] = useState({
    label: "Competência e Vencimento no mesmo mês",
    value: "atual",
  });
  const [competencyExample, setCompetencyExample] = useState("");
  const [applyBillingRule, setApplyBillingRule] = useState(true);

  // animação e view
  const [directions, setDirections] = useState(["left", "right"]);
  const [displayContent, setDisplayContent] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [finishScreen, setFinishScreen] = useState(false);
  const [isSelectingClients, setIsSelectingClients] = useState(true);
  const [customMessage, setCustomMessage] = useState("");
  const [keepValues, setKeepValues] = useState(true);

  // Controle de seleção de clientes
  const [allSelected, setAllSelected] = useState(true);
  const [urlObjects, setUrlObjects] = useState({
    tipocontrato: "",
    cnpj: "",
    razao: "",
    empresa_id: null,
  });
  const [clickNextPage, setClickNextPage] = useState(1);
  const [clickLastPage, setClickLastPage] = useState(1);
  const [clickResponseTotal, setClickResponseTotal] = useState(0);

  return (
    <RevisaoContratoContext.Provider
      value={{
        clientList,
        setClientList,
        isSelectingClients,
        setIsSelectingClients,
        currentClientIndex,
        setCurrentClientIndex,
        banksList,
        setBanksList,
        servicesList,
        setServicesList,
        readjustsList,
        setReadjustsList,
        service,
        setService,
        readjust,
        setReadjust,
        bank,
        setBank,
        deadline,
        setDeadline,
        value,
        setValue,
        billType,
        setBillType,
        NFSeType,
        setNFSeType,
        directions,
        setDirections,
        displayContent,
        setDisplayContent,
        vigency,
        setVigency,
        viewLoading,
        setViewLoading,
        finishScreen,
        setFinishScreen,
        currentContractIndex,
        setCurrentContractIndex,
        errors,
        setErrors,
        customMessage,
        setCustomMessage,
        keepValues,
        setKeepValues,
        contractTypesList,
        setContractTypesList,
        contractType,
        setContractType,
        competency,
        setCompetency,
        competencyExample,
        setCompetencyExample,
        applyBillingRule,
        setApplyBillingRule,
        currentDate,
        disabledButton,
        setDisabledButton,
        paymentTypesList,
        setPaymentTypesList,
        dueDate,
        setDueDate,
        periodicity,
        setPeriodicity,
        allSelected,
        setAllSelected,
        listBillet,
        setListBillet,
        urlObjects,
        setUrlObjects,
        clickNextPage,
        setClickNextPage,
        clickLastPage,
        setClickLastPage,
        clickResponseTotal,
        setClickResponseTotal,
        issueType,
        setIssueType,
      }}
    >
      {children}
    </RevisaoContratoContext.Provider>
  );
};

export { RevisaoContratoContext, RevisaoContratoContextProvider };
